/* eslint-disable */
import { DatePickerToolbar } from '@mui/x-date-pickers/DatePicker/DatePickerToolbar';
import axios from 'axios';
// import token from './authToken';

const localUrl = 'http://localhost:8080';
// const infer_localUrl= 'http://localhost:9990'; 8249!
const infer_localUrl = 'http://localhost:9990';
const url = 'http://localhost:8080';
// API INTEGRATION OFR LOGIN

export const LOGINAPI = async (user, pass) => {
  try {
    // const formData = new FormData();
    // formData.append("username", user);
    // formData.append("password", pass);
    const data = {
      username: user,
      password: pass
    };

    const res = await axios.post(
      // `${infer_localUrl}/user/login?self`,
      'http://localhost:8081/login',
      data,
      {
        headers: {
          Accept: 'application/json'
          // "Content-Type": "multipart/form-data",
          // 'Authorization': await token(), // Uncomment if you need to include an authorization token
        }
      }
    );
    console.log('response', res);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

export const VIDEOSTARTAPI = async (token) => {
  try {
    const res = await axios.get(`${infer_localUrl}/camera/start?self`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    // return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};
export const getCameraData = async () => {
  const url = 'http://localhost:8081/camera/get';
  try {
    const response = await axios.get(url, {
      headers: {
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling getCameraData API: ', error);
    const url2 = url.replace('localhost', '10.115.67.9');
    try {
      const response = await axios.get(url2, {
        headers: {
          Accept: 'application/json'
          // Authorization: await token()
        }
      });
      const data = response.data;
      return data;
    } catch (error) {
      console.log('Error Calling getCameraData API: ', error);
      throw error;
    }
    // throw error;
  }
};

export const filter_user_details = async (body) => {
  try {
    const url = `http://localhost:8081/filter`;
    console.log('my body', body);
    const response = await axios.post(url, body, {
      headers: {
        // 'Content-Type': 'application/json',
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    // const data = response.data;
    console.log('filter users', response);
    return response;
  } catch (error) {
    console.log('Error Calling filterUserData API: ', error);
    throw error;
  }
};

export const delete_user_details = async (userId) => {
  try {
    const url = `http://localhost:8081/delete/${userId}`;
    console.log('my userId', userId);
    const response = await axios.delete(url, {
      headers: {
        // 'Content-Type': 'application/json',
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    // const data = response.data;
    console.log('delete user response', response);
    return response;
  } catch (error) {
    console.log('Error Calling deleteUserData API: ', error);
    throw error;
  }
};

export const edit_user_details = async (userId, body) => {
  try {
    const url = `http://localhost:8081/edit/${userId}`;
    console.log('my body', body);
    const response = await axios.post(url, body, {
      headers: {
        // 'Content-Type': 'application/json',
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    // const data = response.data;
    console.log('edit user response', response);
    return response;
  } catch (error) {
    console.log('Error Calling editUserData API: ', error);
    throw error;
  }
};

export const create_user_details_python = async (body) => {
  try {
    const url = 'http://localhost:8081/create';
    console.log('my body', body);

    const response = await axios.post(url, body, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
      // responseType: 'blob',  // Change this to blob to handle streaming data
      // timeout: 10000
    });
    console.log('ressex', response);

    // Create a URL for the blob response
    // const videoStreamUrl = URL.createObjectURL(response.data);

    // console.log("Video Stream URL:", videoStreamUrl);
    return response;
  } catch (error) {
    console.error('Error Calling createUserData API: ', error);
    throw error;
  }
};

export const preview_user_details = async () => {
  try {
    const url = 'http://localhost:9990/preview_user';
    // const response = await axios.get(url, {
    //   headers: {
    //     Accept: "application/json",
    //     // Authorization: await token()
    //   },
    // });
    const response = await axios.get(url, {
      headers: {
        Accept: 'multipart/x-mixed-replace; boundary=frame'
      },
      responseType: 'stream'
    });
    const data = response.data;
    console.log('video data', data);
    return data;
  } catch (error) {
    console.log('Error Calling previewUser API: ', error);
    throw error;
  }
};

// export const create_user_details_python = async (body) => {
//   try {
//     const url = "http://0.0.0.0:9990/register_user";
//     console.log("my body", body);
//     const response = await axios.post(url, body, {
//       headers: {
//         'Content-Type': 'application/json',
//         Accept: "*/*",  // Accept any content type
//       },
//       responseType: 'arraybuffer',  // Change this to arraybuffer
//       timeout: 30000  // Increase timeout to 30 seconds
//     });

//     console.log("Response received:", response);

//     // Check the content type of the response
//     const contentType = response.headers['content-type'];
//     console.log("Content-Type:", contentType);

//     if (contentType.includes('image')) {
//       // If it's an image, create a blob URL
//       const blob = new Blob([response.data], { type: contentType });
//       const videoStreamUrl = URL.createObjectURL(blob);
//       console.log("Video Stream URL:", videoStreamUrl);
//       return videoStreamUrl;
//     } else {
//       // If it's not an image, it might be JSON or text
//       const textData = new TextDecoder().decode(response.data);
//       console.log("Text data:", textData);
//       return textData;
//     }
//   } catch (error) {
//     console.error("Error Calling createUserData API: ", error);
//     if (error.response) {
//       console.error("Error data:", error.response.data);
//       console.error("Error status:", error.response.status);
//       console.error("Error headers:", error.response.headers);
//     } else if (error.request) {
//       console.error("No response received:", error.request);
//     } else {
//       console.error("Error message:", error.message);
//     }
//     throw error;
//   }
// };

// export const create_user_details_python = async (body) => {
//   try {
//     const url = "http://0.0.0.0:9990/register_user";
//     console.log("my body", body);
//     const response = await axios.post(url, body, {
//       headers: {
//         'Content-Type': 'application/json',
//         Accept: "*/*",  // Accept any content type
//       },
//       responseType: 'arraybuffer',  // Expect binary data
//       // timeout: 30000  // Increase timeout to 30 seconds
//     });

//     console.log("Response received:", response);

//     // Create a blob from the response data
//     const blob = new Blob([response.data], { type: 'multipart/x-mixed-replace; boundary=frame' });
//     const videoStreamUrl = URL.createObjectURL(blob);

//     console.log("Video Stream URL:", videoStreamUrl);

//     return videoStreamUrl;
//   } catch (error) {
//     console.error("Error Calling createUserData API: ", error);
//     if (error.response) {
//       console.error("Error data:", error.response.data);
//       console.error("Error status:", error.response.status);
//       console.error("Error headers:", error.response.headers);
//     } else if (error.request) {
//       console.error("No response received:", error.request);
//     } else {
//       console.error("Error message:", error.message);
//     }
//     throw error;
//   }
// };

export const create_user_details = async (body) => {
  try {
    const url = 'http://localhost:8081/create';
    console.log('my body', body);
    const response = await axios.post(url, body, {
      headers: {
        // 'Content-Type': 'application/json',
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    // const data = response.data;
    console.log('resulttt', response);
    return response;
  } catch (error) {
    console.log('Error Calling createUserData API: ', error);
    throw error;
  }
};

export const get_user_details = async () => {
  try {
    const url = 'http://localhost:8081/get_users';
    const response = await axios.get(url, {
      headers: {
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    const data = response.data;
    console.log('user data', data);
    return data;
  } catch (error) {
    console.log('Error Calling getUserData API: ', error);
    throw error;
  }
};
export const cameraCheckImg = async (body) => {
  try {
    const url = 'http://localhost:9990/camera/connect/';
    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    throw error;
  }
};
export const deleteZoneData = async (body) => {
  const url = 'http://localhost:8081/zone/delete';
  try {
    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling deleteZoneData API: ', error);
    try {
      const url2 = url.replace('localhost', '10.115.67.9');
      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json'
          // Authorization: await token()
        }
      });
      const data = response.data;
      return data;
    } catch (error) {
      console.log('Error Calling deleteZoneData API: ', error);
      throw error;
    }
    // throw error;
  }
};
export const addCameraWithZone = async (body) => {
  const url = 'http://localhost:8081/camera/create';
  try {
    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    try {
      const url2 = url.replace('localhost', '10.115.67.9');
      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json'
          // Authorization: await token()
        }
      });
      const data = response.data;
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error;
    }
    // throw error;
  }
};
export const getZoneData = async (body) => {
  const url = 'http://localhost:8081/zone/get';
  try {
    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling getZoneData API: ', error);
    try {
      const url2 = url.replace('localhost', '10.115.67.9');
      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json'
          // Authorization: await token()
        }
      });
      const data = response.data;
      return data;
    } catch (error) {
      console.log('Error Calling getZoneData API: ', error);
      throw error;
    }
    // throw error;
  }
};

export const IMAGESTREAM = async (path) => {
  try {
    // console.log("path is found", path)
    const res = await axios.get(`${infer_localUrl}/image/${path}`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

export const BULK_DATA_DOWNLOAD = async (start_date, end_date) => {
  try {
    // console.log("path is found", path)
    const data = {
      startDate: start_date,
      endDate: end_date
    };
    const res = await axios.post(`${localUrl}/data/bulk/bulk_download`, data, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

// get_default_env_confs
export const GET_DEFAULT_ENV_CONFS = async (path) => {
  try {
    // console.log("path is found", path)
    const res = await axios.get(`${infer_localUrl}/settings/get_default_env_confs`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

// GET THROUGHPUT CHART API
export const GET_THROUGHPUT = async (date) => {
  try {
    // console.log("path is found", path)
    const res = await axios.post('http://localhost:8081/throughput', date, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    console.log('area chart data', res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

// THIS API FOR PRODUCT COUNT
export const GET_PRODUCT_COUNT = async (path) => {
  try {
    // console.log("path is found", path)
    const res = await axios.get(`${localUrl}/data/get_data_last_4hr/${path}`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

// Reset to Default Environmental Configurations reset_to_default_env_confs
export const RESET_TO_DEFAULT_ENV_CONFS = async (path) => {
  try {
    // console.log("path is found", path)
    const res = await axios.get(`${infer_localUrl}/settings/reset_to_default_env_confs`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

// Get Current Environmental Configurations  get_current_env_confs

export const GET_CURRENT_ENV_CONFS = async (path) => {
  try {
    // console.log("path is found", path)
    const res = await axios.get(`${infer_localUrl}/settings/get_current_env_confs`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

// GET /settings/set_current_env_confs

export const SET_CURRENT_ENV_CONFS = async (path) => {
  try {
    // console.log("path is found", path)
    const res = await axios.post(`${infer_localUrl}/settings/set_current_env_confs`, path, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

// GET /settings/set_current_roi

export const SET_CURRENT_ROI = async (path) => {
  try {
    // console.log("path is found", path)
    const res = await axios.post(`${infer_localUrl}/settings/set_current_roi`, path, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

//  GET /settings/get_current_roi
export const GET_CURRENT_ROI = async (path) => {
  try {
    // console.log("path is found", path)
    const res = await axios.get(`${infer_localUrl}/settings/get_current_roi`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

//  GET /settings/get_default_roi
export const GET_DEFAULT_ROI = async () => {
  try {
    // console.log("path is found", path)
    const res = await axios.get(`${infer_localUrl}/settings/get_default_roi`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

// GET /settings/reset_to_default_roi
export const RESET_TO_DEFAULT_ROI = async () => {
  try {
    // console.log("path is found", path)
    const res = await axios.get(`${infer_localUrl}/settings/reset_to_default_roi`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

//  Get Current Depth
export const GET_CURRENT_DEPTH = async () => {
  try {
    // console.log("path is found", path)
    const res = await axios.get(`${infer_localUrl}/settings/get_current_depth`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

// Auto Calibrate Depth

export const AUTO_CALIBRATE_DEPTH = async () => {
  try {
    // console.log("path is found", path)
    const res = await axios.get(`${infer_localUrl}/settings/auto_calibrate_depth`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

// Save Calibrated Depth
export const SAVE_CALIBRATED_DEPTH = async (values) => {
  try {
    // console.log("path is found", path)
    const res = await axios.post(`${infer_localUrl}/settings/save_calibrated_depth`, values, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

//Get ROI Image
export const GET_ROI_IMG = async () => {
  try {
    // console.log("path is found", path)
    const res = await axios.get(`${infer_localUrl}/settings/get_roi_image`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

//  Reset AI Engine API
export const RESET_AI_ENGINE = async () => {
  try {
    // console.log("path is found", path)
    const res = await axios.get(`${infer_localUrl}/manage/tare_weight`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};
export const GetOneUser = async (body) => {
  try {
    const res = await axios.post(`http://localhost:8081/get_user`, body, {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!res.data) {
      throw new Error('No data received from server');
    }

    return res; // Return the full response instead of just res.data
  } catch (error) {
    console.error('Error getting user details: ', error);
    throw error; // Rethrow the error to be handled by the component
  }
};

export const GetAllCameras = async () => {
  try {
    // console.log("path is found", body)
    const res = await axios.get(`http://localhost:8081/get_cameras`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res.data;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};
export const GetAnalysisDetails = async () => {
  try {
    // console.log("path is found", body)
    const res = await axios.post(`http://localhost:8081/get_analysis`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res.data;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};
export const DownloadEvidence = async (date) => {
  try {
    // console.log("path is found", body)
    const res = await axios.get(`http://127.0.0.1:9990/camera/download-evidences?date=${date}`, {
      headers: {
        Accept: 'application/json'
        //   Authorization: await token(),
      }
    });
    // console.log(res.data);
    return res.data;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};
export const createCamera = async ({ camera_address, camera_name }) => {
  try {
    const response = await axios.post(
      'http://localhost:8081/camera/create',
      {
        camera_address,
        camera_name
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }
      }
    );

    return response;
  } catch (error) {
    console.error('Error creating camera:', error);
    throw error;
  }
};
